import ClassNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const TableHeader = ({ isSelected }) => {
    const { t } = useTranslation();
    return (
        <tr
            className={ClassNames('folder', {
                selected: isSelected
            })}
        >
            <th>{t('Common.file')}</th>
            <th className="size" style={{ textAlign: 'left' }}>
                {t('Common.size')}
            </th>
            <th className="modified" style={{ textAlign: 'left' }}>
                {t('Common.last_modified')}
            </th>
            <th className="actions">{t('Common.actions')}</th>
        </tr>
    );
};
